import classNames from "classnames";
import { FunctionComponent, ReactElement, useState } from "react";
import Button from "rivals/components/shared/Button";
import FormInput from "rivals/components/shared/Form/TextInput";
import { InputType } from "rivals/components/shared/Form/TextInput/types";
import styles from "./PasswordInput.module.scss";
import type { Props } from "./types";

const PasswordInput: FunctionComponent<Props> = ({
  className,
  data = "",
  feedback = "",
  hint = "",
  label,
  value,
  onBlur,
  onChange
}): ReactElement => {
  const [showPassword, setShowPassword] = useState(false);
  const inputClasses = classNames([styles.passwordWrapper], className);

  return (
    <div className={inputClasses}>
      <FormInput
        data={data}
        feedback={feedback}
        hint={hint}
        htmlFor="password"
        label={label}
        onBlur={onBlur}
        onChange={onChange}
        required={false}
        type={showPassword ? InputType.TEXT : InputType.PASSWORD}
        value={value}
      />
      <Button
        backgroundColor="transparent"
        borderColor="transparent"
        buttonText={showPassword ? "Hide" : "Show"}
        className={styles.togglePasswordVisibility}
        data={`${data}-show-hide`}
        inverted
        onClick={(): void => setShowPassword(!showPassword)}
        size="small"
      />
    </div>
  );
};

export default PasswordInput;
